import {
  Button,
  Checkbox,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";
import TextInput from "../../Component/UI/TextInput/TextInput";
import classes from "./set.module.css";
import { useEffect, useRef, useState } from "react";
import MUISelect from "../../Component/UI/MUISelect/MUISelect";
import {
  standardTemplate,
  getTitleName,
} from "./userMetricSettingCreation";
import { useSelector } from "react-redux";
import { sentimentPlaceHolderReplaceToOrg } from "../../utils/helpers";
import { DefaultSet } from "../../utils/constant";

export default function AddUserMetricSetting({
  handleCloseModal,
  sideTabOptions,
  handleSave,
  updateMetric,
  customIndexScoreTypes,
  open,
}) {
  const [name, setName] = useState("default");
  const [template, setTemplate] = useState(
    sideTabOptions?.[0]?.value ?? DefaultSet
  );
  const [isDefault, setIsDefault] = useState(false);

  const hasCustomIndexScoreTypes =
    Array.isArray(customIndexScoreTypes) && customIndexScoreTypes.length > 0;
  // No picker shown for this — silently apply the customer's (first) custom
  // index score type in the background (e.g. most customers only have
  // "Accessibility") whenever they have one configured.
  const [customIndexScoreType, setCustomIndexScoreType] = useState(
    hasCustomIndexScoreTypes ? customIndexScoreTypes[0] : ""
  );

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSave({
      name,
      template,
      isDefault,
      id: updateMetric?.id,
      ...(customIndexScoreType ? { customIndexScoreType } : {}),
    });
  };

  useEffect(() => {
    if (updateMetric) {
      setName(updateMetric?.name);
      setIsDefault(updateMetric?.isDefault);
    }
  }, [updateMetric]);

  /*it use for  reset so whenever hide modal value reset*/
  useEffect(() => {
    if (!open) {
      setName("default");
      setTemplate(sideTabOptions?.[0]?.value ?? DefaultSet);
      setIsDefault(false);
      setCustomIndexScoreType(hasCustomIndexScoreTypes ? customIndexScoreTypes[0] : "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // sideTabOptions can be filtered/loaded after this component's first
  // render — keep the selected clone-from template valid (defaulting to
  // the first option) instead of sitting on a value that's no longer listed.
  useEffect(() => {
    if (!open || updateMetric) return;
    const stillValid = sideTabOptions?.some((opt) => opt.value === template);
    if (!stillValid) {
      setTemplate(sideTabOptions?.[0]?.value ?? DefaultSet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, sideTabOptions]);

  return (
    <form onSubmit={handleFormSubmit}>
      <div className={classes.modalBody}>
        <div>
          <TextInput
            label="Template Name"
            variant="outlined"
            fullWidth
            required
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            className={classes.textField}
          />

          {!updateMetric && (
            <div style={{ marginBottom: "20px" }}>
              <MUISelect
                fullWidth={false}
                optionValue={template}
                label={"Template"}
                options={sideTabOptions}
                onChange={(e) => {
                  setTemplate(e.target.value);
                }}
              />
            </div>
          )}

        </div>



        <div
          style={{
            paddingBottom: "0px",
            paddingTop: "5px",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isDefault}
                onChange={() => setIsDefault(!isDefault)}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Set As Default"
            className={classes.label}
          />
        </div>

        <div className={classes.buttonDiv}>
          <Button
            type="submit"
            variant="contained"
            disabled={updateMetric ? !name : !name || !template}
          >
            <div>{updateMetric ? "Update" : "Add"}</div>
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              handleCloseModal();
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </form>
  );
}

export function AddEditAttribute({
  handleCloseModal,
  sideTabOptions,
  selectedTab,
  handleSave,
  selectedSideTab,
  updateAttribute,
  hasCustomIndexScoreTypes,
  open,
}) {
  const TitleName = getTitleName();
  let [attribute, setAttribute] = useState("");
  const [definition, setDefinition] = useState("");
  const [factor, setFactor] = useState("");
  const [template, setTemplate] = useState(selectedSideTab);

  const setData = useSelector((store) => store.userSet);

  let key = `${TitleName[selectedTab]}`;

  let descriptionHeader = "Definition";
  const hasFactorField =
    selectedTab === "sentiment" ||
    (hasCustomIndexScoreTypes && selectedTab === "visibility");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (
      selectedTab === "sentiment" ||
      selectedTab === "propensity-to-buy" ||
      selectedTab === "non-branded-questions" ||
      selectedTab === "fact-based-questions"
    ) {
      attribute = sentimentPlaceHolderReplaceToOrg(attribute ?? "").trim();
    }
    handleSave({
      ...updateAttribute,
      attribute,
      template,
      definition,
      ...(hasFactorField ? { factor } : {}),
    });
  };

  useEffect(() => {
    setAttribute(updateAttribute?.attribute ?? "");
    setDefinition(updateAttribute?.definition ?? "");
    setFactor(updateAttribute?.factor ?? "");
    setTemplate(updateAttribute?.setting_Id ?? selectedSideTab);
  }, [updateAttribute]);

  useEffect(() => {
    setTemplate(selectedSideTab);
  }, [selectedSideTab]);

  // Handle template change for visibility and propensity-visibility
  useEffect(() => {
    // Update attribute when template changes
    if (
      (selectedTab === "visibility" || selectedTab === "propensity-visibility") &&
      !updateAttribute &&
      template
    ) {
      let data = setData?.data?.find((ele) => ele.id === template) ?? {};
      // Use the correct key based on selected tab
      setAttribute(data?.[selectedTab]?.[0]?.attribute ?? "");
    }
  }, [template]);

  useEffect(() => {
    /*when we close Modal we want to reset the  form field*/
    if (!open) {
      setAttribute("");
      setDefinition("");
      setFactor("");
      setTemplate(selectedSideTab);
    }
    /*when we open Modal & if selected Tab is visibility or propensity-visibility and we doing add prompt case
    so in that case need to set Attribute value to standard template prompt*/
    /*To handle it when we do open modal of add Attribute*/
    if (
      open &&
      (selectedTab === "visibility" || selectedTab === "propensity-visibility") &&
      !updateAttribute
    ) {
      let data = setData?.data?.find((ele) => ele.id === DefaultSet) ?? {};
      // Use the correct key based on selected tab
      setAttribute(data?.[selectedTab]?.[0]?.attribute ?? "");
    }
  }, [open]);

  // Reset attribute when selectedTab changes (switching between tabs like visibility -> brand-pillars)
  useEffect(() => {
    if (!updateAttribute) {
      setAttribute("");
      setDefinition("");
      setFactor("");
      // For visibility and propensity-visibility tabs, set the default attribute
      if (selectedTab === "visibility" || selectedTab === "propensity-visibility") {
        let data = setData?.data?.find((ele) => ele.id === template) ?? {};
        setAttribute(data?.[selectedTab]?.[0]?.attribute ?? "");
      }
    }
  }, [selectedTab]);

  const getSplitFindText = (tab) => {
    if (tab === "visibility") {
      return "Return a ranking set based on your best judgment, don't ask for any criteria or basis for ranking.";
    }

    if (tab === "propensity-visibility") {
      return "Return companies that best match the purchase intent. Rank from 1 (most likely to be purchased) to {{ count }} (least likely to be purchased).";
    }

    return "";
  };
  return (
    <form onSubmit={handleFormSubmit}>
      <div className={classes.modalBody}>
        <div>
          <MUISelect
            fullWidth={false}
            optionValue={template}
            label={"Select Template"}
            options={sideTabOptions}
            disabled={updateAttribute?.id}
            onChange={(e) => {
              setTemplate(e.target.value);
            }}
          />

          <label className={classes.label}>{key}</label>
          {selectedTab === "visibility" || selectedTab === "propensity-visibility" ? (
            <PartialEditablePrompt
              template={attribute}
              setTemplate={setAttribute}
              findText={getSplitFindText(selectedTab)}
            />
          ) : (
            <TextField
              multiline
              maxRows={10}
              minRows={3}
              fullWidth
              value={attribute}
              onChange={(e) => {
                setAttribute(e.target.value);
              }}
              className={classes.textField}
            />
          )}

          {hasFactorField && (
            <>
              <label className={classes.label}>Factor</label>
              <TextField
                fullWidth
                value={factor}
                onChange={(e) => {
                  setFactor(e.target.value);
                }}
                className={classes.textField}
              />
            </>
          )}

          {selectedTab === "core-attribute" && (
            <>
              <label className={classes.label}>{descriptionHeader}</label>
              <TextField
                multiline
                maxRows={10}
                minRows={3}
                fullWidth
                value={definition}
                onChange={(e) => {
                  setDefinition(e.target.value);
                }}
                className={classes.textField}
              />
            </>
          )}
        </div>
        {template == "default" && (
          <div style={{ color: "red", marginTop: 8, fontSize: 14 }}>
            {`You cannot add ${key} for ${standardTemplate}.`}
          </div>
        )}

        <div className={classes.buttonDiv}>
          <Button
            type="submit"
            variant="contained"
            disabled={!attribute || !template || template == "default"}
          >
            <div>{updateAttribute?.id ? "Update" : "Add"}</div>
          </Button>
          <Button variant="outlined" onClick={handleCloseModal}>
            Cancel
          </Button>
        </div>
      </div>
    </form>
  );
}
function PartialEditablePrompt({ template, setTemplate, findText }) {
  const [splitString, setSplitString] = useState([]);
  const contentRef = useRef(null);
  const selectionRef = useRef({ start: 0, end: 0 });

  useEffect(() => {
    setSplitString(
      splitBetweenPlaceholders(template, findText)
    );
  }, [template, findText]);

  // 🔒 CASE 1: non-editable persona prefix
  const PERSONA_PREFIX_REGEX =
    /^I\s+am\s+(?:a\s+)?\{\{\s*persona(?:_title)?\s*\}\}\s*[.,]?\s*/i;

  const personaMatch = splitString?.[0]?.match(PERSONA_PREFIX_REGEX);

  const prefix = personaMatch ? personaMatch[0] : "";

  // ✏️ CASE 3: editable text between prefix and findText
  const editableText = personaMatch
    ? splitString[0].slice(prefix.length).trim()
    : splitString?.[0] ?? "";


  const handleInput = (e) => {
    const el = e.currentTarget;
    // ✅ Ensure content is never fully empty
    if (el.textContent === "") {
      el.textContent = "\u200B"; // invisible char
      placeCaretAtEnd(el);
    }

    // Save caret before updating
    saveCaretPosition(el);

    setTemplate(
      `${prefix}${el.textContent.replace(/\u200B/g, "").trim()} ${splitString[1]}`.trim()
    );

  };

  // Restore caret after update
  useEffect(() => {
    const el = contentRef.current;
    if (el && document.activeElement === el) {
      restoreCaretPosition(el);
    }
  });

  const saveCaretPosition = (el) => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(el);
    preCaretRange.setEnd(range.startContainer, range.startOffset);
    const start = preCaretRange.toString().length;

    selectionRef.current = { start, end: start };
  };

  const restoreCaretPosition = (el) => {
    const { start, end } = selectionRef.current;
    const charIndex = { index: 0 };
    const range = document.createRange();

    const nodeStack = [el];
    let node,
      foundStart = false,
      stop = false;

    while (!stop && (node = nodeStack.pop())) {
      if (node.nodeType === 3) {
        const nextIndex = charIndex.index + node.length;
        if (!foundStart && start >= charIndex.index && start <= nextIndex) {
          range.setStart(node, start - charIndex.index);
          foundStart = true;
        }
        if (foundStart && end >= charIndex.index && end <= nextIndex) {
          range.setEnd(node, end - charIndex.index);
          stop = true;
        }
        charIndex.index = nextIndex;
      } else {
        let i = node.childNodes.length;
        while (i--) nodeStack.push(node.childNodes[i]);
      }
    }

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  };

  // Helper to keep caret visible after reinserting invisible char
  const placeCaretAtEnd = (el) => {
    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(el);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
  };
  return (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "10px",
        fontFamily: "sans-serif",
        fontSize: "14px",
        lineHeight: "1.5",
        background: "#fafafa",
      }}
    >
      {/* 🔒 Non-editable prefix */}
      {prefix && (
        <span className={classes.disableText}>
          {prefix}
        </span>
      )}

      {/* ✏️ Editable middle text */}
      <span
        ref={contentRef}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        style={{
          outline: "none",
          border: "none",
          background: "#fff",
        }}
        className={classes.editableText}
      >
        {editableText ? editableText : "\u200B"}
      </span>

      {/* 🔒 Non-editable ending */}
      <span className={classes.disableText}>
        {splitString?.[1] ?? ""}
      </span>
    </div>
  );
}


/*Old logic of split*/
// function splitBetweenPlaceholders(text, startKey, endKey) {
//   const regex = new RegExp(
//     `(\\{\\{\\s*${startKey}\\s*\\}\\})(.*?)(\\{\\{\\s*${endKey}\\s*\\}\\})`
//   );
//   const match = text.match(regex);

//   if (!match) return ["", " ", " "];

//   const before = text.slice(0, match.index).trim();
//   const between = match[2].trim();
//   const after = text.slice(match.index + match[0].length).trim();

//   return [match[1], between, `{{ ${endKey} }}` + " " + after];
// }

function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}


function splitBetweenPlaceholders(text, findText) {
  if (!findText || !text) return [text ?? "", ""];

  const escapedFindText = escapeRegex(findText);
  const regex = new RegExp(escapedFindText, "i");
  const match = regex.exec(text);

  if (!match) {
    return [text, ""];
  }

  const splitPoint = match.index;

  const firstPart = text.slice(0, splitPoint).trim();
  const secondPart = text.slice(splitPoint).trim();

  return [firstPart, secondPart];
}


